import { type ReactNode } from "react";
import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { AppSettingsProvider } from "@/contexts/AppSettingsContext";
import { PageTitleProvider } from "@/contexts/PageTitleContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { UserbackProvider } from "@/contexts/UserbackContext";

interface ProvidersProps {
	children: ReactNode;
}

export const Providers = ({ children }: ProvidersProps) => {
	return (
		<PostHogProvider client={posthog}>
			<AppSettingsProvider>
				<PageTitleProvider>
					<AuthProvider>
						<UserbackProvider>{children}</UserbackProvider>
					</AuthProvider>
				</PageTitleProvider>
			</AppSettingsProvider>
		</PostHogProvider>
	);
};
